// eslint-disable-next-line react-native/split-platform-components
import { PermissionsAndroid, Platform } from "react-native"

export async function requestAudioPermission(): Promise<boolean> {
  if (Platform.OS == "android") {
    const granted = await PermissionsAndroid.request(PermissionsAndroid.PERMISSIONS.RECORD_AUDIO, {
      title: "Microphone Permission",
      message: "Home AI needs access to your microphone so you can chat with Pixi",
      buttonNegative: "Cancel",
      buttonPositive: "OK",
    })
    return granted === PermissionsAndroid.RESULTS.GRANTED
  } else {
    return true
  }
}

export async function checkAudioPermission(): Promise<boolean> {
  if (Platform.OS == "android") {
    return await PermissionsAndroid.check(PermissionsAndroid.PERMISSIONS.RECORD_AUDIO)
  } else {
    return false
  }
}

export async function requestExternalStoreageRead(): Promise<boolean> {
  if (Platform.OS == "android") {
    const granted = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.READ_EXTERNAL_STORAGE,
      {
        title: "Storage Permission",
        message: "Home AI needs access to your storage",
        buttonNegative: "Cancel",
        buttonPositive: "OK",
      },
    )
    return granted === PermissionsAndroid.RESULTS.GRANTED
  } else {
    return true
  }
}

export async function requestContactPermissions(): Promise<boolean> {
  if (Platform.OS === "android") {
    const res = await PermissionsAndroid.requestMultiple([
      PermissionsAndroid.PERMISSIONS.READ_CONTACTS,
      PermissionsAndroid.PERMISSIONS.WRITE_CONTACTS,
    ])

    return (
      res["android.permission.READ_CONTACTS"] === "granted" &&
      res["android.permission.WRITE_CONTACTS"] === "granted"
    )
  }

  return false
}

export async function requestCameraPermissions(): Promise<boolean> {
  if (Platform.OS === 'android') {
    const res = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.CAMERA
    );

    return res === 'granted';
  }

  return false;
}

export * from './usePermission';

